import { useCallback, useMemo } from 'react'
import {
  gql,
  useApolloClient,
  ApolloClient,
  DocumentNode
} from '@apollo/client'
import { Category } from '@@partner:types:app'
import { GQL_ID, GQL_Edge } from '@@partner:types:graphql'

export interface CategoriesWithParentQuery {
  categories: GQL_Edge<Category[]>
}

export interface CommmonQueryVariables {
  skipIds?: GQL_ID[]
  style?: string
}
export interface CategoriesWithParentQueryVariables
  extends CommmonQueryVariables {
  id?: GQL_ID
  parentId?: GQL_ID | null
}

export const GQL_QUERY_ROOT_CATEGORIES = gql`
  query ($skipIds: [NumberOrString], $style: String) {
    categories: allCategories(
      filter: {
        and: [
          { fields: ["parent_id"], op: "is_null" }
          { fields: "id", op: "not_contains", value: $skipIds }
        ]
      }
      pager: { limit: 9999 }
    ) {
      edges {
        id
        name
        status
        parent_id
        preview_size
        customer_order
        icon(style: $style) {
          url
        }
      }
    }
  }
`

export const GQL_QUERY_CATEGORIES_WITH_PARENT = gql`
  query (
    $id: NumberOrString
    $parentId: NumberOrString
    $skipIds: [NumberOrString]
    $style: String
  ) {
    categories: allCategories(
      filter: {
        and: [
          {
            or: [
              { fields: ["parent_id"], op: "eq", value: [$parentId] }
              { fields: ["id"], op: "eq", value: [$id] }
            ]
          }
          { fields: "id", op: "not_contains", value: $skipIds }
        ]
      },
      pager: { limit: 9999 }
    ) {
      edges {
        id
        name
        parent_id
        preview_size
        customer_order
        status
        icon(style: $style) {
          url
        }
        # childrens {
        #   id
        #   name
        #   parent_id
        # }
      }
    }
  }
`

const makeFetcher =
  <Query, QueryVariables extends CommmonQueryVariables | Record<string, any>>(
    client: ApolloClient<any>,
    query: DocumentNode
  ) =>
    async (variables?: QueryVariables) => {
      const { data } = await client.query<Query, QueryVariables>({
        query,
        variables
      })
      return data
    }

export const useCategoriesFetcher = () => {
  const client = useApolloClient()

  return useMemo(
    () => ({
      fetchRootCategories: makeFetcher<CategoriesWithParentQuery, any>(
        client,
        GQL_QUERY_ROOT_CATEGORIES
      ),

      fetchCategories: makeFetcher<
        CategoriesWithParentQuery,
        CategoriesWithParentQueryVariables
      >(client, GQL_QUERY_CATEGORIES_WITH_PARENT)
    }),
    [ client ]
  )
}
